import {nextTick} from 'vue';
import * as bootstrap from 'bootstrap';

function createBootstrapDropdownInstance(el) {
    if (!document.body.contains(el)) {
        console.warn("L'élément select n'est pas présent dans le DOM.");
        return;
    }

    const placeholderText = el.dataset.placeholder || "Sélectionner une option";
    const maxItems = el.dataset.count;

    const filteredData = JSON.parse(el.dataset.filtered || '[]');

    // Vérification supplémentaire du parent
    if (!el.parentNode) {
        console.warn("Le select n'a pas de parent, impossible de continuer.");
        return;
    }

    // Créer un wrapper pour le dropdown
    const wrapper = document.createElement('div');
    wrapper.className = 'dropdown bootstrap-select';
    wrapper.style.width = '100%';

    // Créer le bouton dropdown
    const button = document.createElement('button');
    button.className = 'btn dropdown-toggle';
    button.setAttribute('type', 'button');
    button.setAttribute('data-bs-toggle', 'dropdown');
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML = `<span class="filter-option">${placeholderText}</span>`;

    // Créer le menu dropdown
    const dropdownMenu = document.createElement('div');
    dropdownMenu.className = 'dropdown-menu w-100 text-start p-3';

    // Ajouter le titre et sous-titre si présents
    if (el.dataset.title || el.dataset.subtitle) {
        const headerDiv = document.createElement('div');
        headerDiv.className = 'col-md-12 mt-0';
        headerDiv.innerHTML = `
            <p class="h4 text-black my-1">${el.dataset.title || "Titre par défaut"}</p>
            <p class="text-gray-60 m-0">${el.dataset.subtitle || ""}</p>
        `;
        dropdownMenu.appendChild(headerDiv);
    }

    // Créer la liste des options
    const optionsContainer = document.createElement('div');
    optionsContainer.className = 'row g-0 g-md-3';

    let allOptions = [];

    if (filteredData.length > 0) {
        allOptions = filteredData.map((item) => ({
            value: item.id,
            label: item.title,
            customProperties: {
                image: item.image || "",
                discount: item.discount || "",
                originalPrice: item.originalPrice || "",
                initialprice: item.initialprice || "",
                price: item.price || "",
                round: item.round_min || "",
            },
        }));
    } else {
        allOptions = Array.from(el.options).map((option) => ({
            value: option.value,
            label: option.text,
            customProperties: {
                image: option.dataset.image || "",
                discount: option.dataset.discount || "",
                originalPrice: option.dataset.originalPrice || "",
                initialprice: option.dataset.initialprice || "",
                price: option.dataset.price || "",
                round: option.dataset.round || "",
            },
        }));
    }

    // Limiter le nombre d'options
    const options = allOptions.filter(v => v.value);

    // Créer les éléments d'option
    options.forEach((option) => {
        const optionDiv = document.createElement('div');
        optionDiv.className = 'col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4';
        optionDiv.setAttribute('data-value', option.value);

        const isSelected = el.value === option.value;

        optionDiv.innerHTML = `
            <div class="card card-product is-small ${isSelected ? 'is-selected' : ''}">
                <div class="row g-0 h-100 d-flex align-items-center">
                    <div class="col-1 d-flex d-md-none d-lg-none d-xl-flex justify-content-end">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" ${isSelected ? 'checked="checked"' : ''}>
                        </div>
                    </div>
                    <div class="col-5">
                        ${option.customProperties.discount ? `<div class="badge bg-danger text-white text-center fw-bolder">${option.customProperties.discount}</div>` : ''}
                        <img src="${option.customProperties.image}" class="card-img" alt="${option.label}">
                    </div>
                    <div class="col-6 col-md-7 col-lg-7 col-xl-6">
                        <div class="card-content">
                            <div class="card-title">
                                <p class="h6 fw-bolder text-black text-uppercase">${option.label}</p>
                            </div>
                            <div class="card-price">
                                <p class="small fw-normal m-0">À partir de</p>
                                <div class="price d-flex flex-row align-items-baseline pt-2">
                                    ${option.customProperties.originalPrice ? `<span class="old-price fw-normal text-decoration-line-through small fs-xxl-6 me-2">${option.customProperties.originalPrice}€</span>` : ''}
                                    ${option.customProperties.price ? `<span class="price fw-bolder text-info small fs-xl-6 fs-xxl-5 p-lg-0 p-xl-0">${option.customProperties.price}€</span>` : ''}
                                    ${option.customProperties.round ? `<span class="nb fw-normal small">/${option.customProperties.round} tours</span>` : ''}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;

        // Ajouter un gestionnaire d'événements pour la sélection
        optionDiv.addEventListener('click', () => {
            // Mettre à jour la valeur du select
            el.value = option.value;

            // Déclencher l'événement change
            const event = new Event('change', {bubbles: true});
            el.dispatchEvent(event);

            // Mettre à jour le texte du bouton
            button.querySelector('.filter-option').textContent = option.label;

            // Mettre à jour la classe selected
            optionsContainer.querySelectorAll('.card').forEach(card => {
                card.classList.remove('is-selected');
            });
            optionDiv.querySelector('.card').classList.add('is-selected');

            // Mettre à jour les radios
            optionsContainer.querySelectorAll('.form-check-input').forEach(input => {
                input.checked = false;
            });
            optionDiv.querySelector('.form-check-input').checked = true;
        });

        optionsContainer.appendChild(optionDiv);
    });

    dropdownMenu.appendChild(optionsContainer);

    // Cacher le select original
    el.style.display = 'none';

    // Générer un ID unique pour le dropdown menu
    const dropdownId = 'dropdown-menu-' + Math.random().toString(36).substr(2, 9);
    dropdownMenu.id = dropdownId;

    // Ajouter des classes pour permettre au menu de prendre toute la largeur
    dropdownMenu.classList.add('w-100');

    // Ajouter un style pour positionner le menu correctement
    dropdownMenu.style.position = 'absolute';
    dropdownMenu.style.inset = 'auto 0 auto 0';
    dropdownMenu.style.zIndex = '1000';

    // Lier le bouton au menu dropdown
    button.setAttribute('data-bs-target', '#' + dropdownId);

    // Ajouter les éléments au DOM
    wrapper.appendChild(button);
    wrapper.appendChild(dropdownMenu);
    // Ajouter le wrapper après le select original
    el.parentNode.insertBefore(wrapper, el.nextSibling);

    // Initialiser le dropdown Bootstrap
    el._dropdown = new bootstrap.Dropdown(button);

    // Déplacer le dropdown menu après l'initialisation pour qu'il prenne toute la largeur
    // tout en évitant l'erreur "this._menu is null"
    setTimeout(() => {
        if (wrapper.contains(dropdownMenu)) {
            wrapper.removeChild(dropdownMenu);
            el.parentNode.insertBefore(dropdownMenu, wrapper.nextSibling);
        }
    }, 0);

    // Stocker des références pour le nettoyage
    el._dropdownWrapper = wrapper;
    el._dropdownMenu = dropdownMenu;
}

export default {
    mounted(el) {
        createBootstrapDropdownInstance(el);
    },

    updated(el, binding) {
        if (
            binding.value &&
            binding.oldValue &&
            JSON.stringify(binding.value) === JSON.stringify(binding.oldValue)
        ) {
            return;
        }

        // Supprimer l'ancien dropdown
        if (el._dropdown) {
            el._dropdown.dispose();
        }
        if (el._dropdownWrapper && el._dropdownWrapper.parentNode) {
            el._dropdownWrapper.parentNode.removeChild(el._dropdownWrapper);
        }
        if (el._dropdownMenu && el._dropdownMenu.parentNode) {
            el._dropdownMenu.parentNode.removeChild(el._dropdownMenu);
        }
        el._dropdown = null;
        el._dropdownWrapper = null;
        el._dropdownMenu = null;

        // Délai légèrement plus long pour s'assurer que le DOM est stable
        setTimeout(() => {
            if (document.body.contains(el) && el.parentNode) {
                createBootstrapDropdownInstance(el);
            }
        }, 50);
    },

    unmounted(el) {
        if (el._dropdown) {
            el._dropdown.dispose();
        }
        if (el._dropdownWrapper && el._dropdownWrapper.parentNode) {
            el._dropdownWrapper.parentNode.removeChild(el._dropdownWrapper);
        }
        if (el._dropdownMenu && el._dropdownMenu.parentNode) {
            el._dropdownMenu.parentNode.removeChild(el._dropdownMenu);
        }
        el._dropdown = null;
        el._dropdownWrapper = null;
        el._dropdownMenu = null;
    },
};
